import { render, staticRenderFns } from "./JeecgOrderModalForJVexTable.vue?vue&type=template&id=700d1b1f&scoped=true&"
import script from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d1b1f",
  null
  
)

export default component.exports